import React, { useEffect, useState } from "react";
import axios from "axios";
import { config } from "../../../config";
import UpdateMenu from "./UpdateMenu";

const apiUrl = config.apiUrl;

const ViewMenu = () => {
  const [menus, setMenus] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [editingMenu, setEditingMenu] = useState(null);
  const [formData, setFormData] = useState({ 
    name: "",
    url: "",
    menu_type: "header",
    order: 1,
  });

  useEffect(() => {
    const fetchMenus = async () => {
      try {
        const response = await axios.get(`${apiUrl}/menus`);
        setMenus(response.data);
        setLoading(false);
      } catch (err) {
        console.error("Error fetching Menus:", err);
        setError("Failed to load Menus.");
        setLoading(false);
      }
    };
    fetchMenus();
  }, []);

  const handleDelete = async (id) => {
    if (window.confirm("Are you sure you want to delete this Menu?")) {
      try {
        await axios.delete(`${apiUrl}/menudelete/${id}`);
        setMenus((prev) => prev.filter((menu) => menu.id !== id));
      } catch (err) {
        console.error("Error deleting Menu:", err);
        setError("Failed to delete Menu.");
      }
    }
  };

  const handleEditClick = (menu) => {
    setEditingMenu(menu.id);
    setFormData({ 
      name: menu.name,
      url: menu.url,
      menu_type: menu.menu_type,
      order: menu.order,
    });
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({ 
      ...formData, 
      [name]: name === "order" ? parseInt(value) : value 
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!editingMenu) {
      setError("No menu selected for editing.");
      return;
    }
    try {
      await axios.put(`${apiUrl}/menusupdate/${editingMenu}`, formData);
      alert("Menu updated successfully");
      setMenus((prev) =>
        prev.map((menu) =>
          menu.id === editingMenu ? { ...menu, ...formData } : menu
        )
      );
      setEditingMenu(null);
    } catch (err) {
      console.error("Error updating menu:", err);
      setError("Failed to update menu.");
    }
  };

  if (loading) {
    return <div>Loading...</div>;
  }

  return (
    <div className="p-6 max-w-6xl mx-auto bg-white shadow rounded">
      <h2 className="text-2xl font-bold mb-4 text-center">Menus</h2>
      {error && <p className="text-red-500">{error}</p>}
      <div className="overflow-x-auto">
        <table className="w-full border-collapse border border-gray-300">
          <thead>
            <tr>
              <th className="border border-gray-300 px-4 py-2">Name</th>
              <th className="border border-gray-300 px-4 py-2">URL</th>
              <th className="border border-gray-300 px-4 py-2">Menu Type</th>
              <th className="border border-gray-300 px-4 py-2">Order</th>
              <th className="border border-gray-300 px-4 py-2">Actions</th>
            </tr>
          </thead>
          <tbody>
            {menus.map((menu) => (
              <tr key={menu.id}>
                <td className="border border-gray-300 px-4 py-2">{menu.name}</td>
                <td className="border border-gray-300 px-4 py-2">
                  <a href={menu.url} target="_blank" rel="noopener noreferrer" className="text-blue-600 hover:underline">
                    {menu.url.length > 30 ? `${menu.url.substring(0, 30)}...` : menu.url}
                  </a>
                </td>
                <td className="border border-gray-300 px-4 py-2 capitalize">{menu.menu_type}</td>
                <td className="border border-gray-300 px-4 py-2">{menu.order}</td>
                <td className="flex flex-col gap-2 border border-gray-300 px-4 py-2">
                  <button
                    onClick={() => handleEditClick(menu)}
                    className="bg-blue-600 text-white px-3 py-1 rounded hover:bg-blue-700 mr-2"
                  >
                    Edit
                  </button>
                  <button
                    onClick={() => handleDelete(menu.id)}
                    className="bg-red-600 text-white px-3 py-1 rounded hover:bg-red-700"
                  >
                    Delete
                  </button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      {editingMenu && (
        <UpdateMenu
          formData={formData}
          handleChange={handleChange}
          handleSubmit={handleSubmit}
          onCancel = {() => setEditingMenu(null)}
          loading={loading}
          error={error}
        />
      )}
    </div>
  );
};

export default ViewMenu;